@if (!isCondensed) {
	<ngx-accordion [open]="timelineItems | isPrimaryTimelineItem: 'isCurrent'">
		@for (item of timelineItems; track item; let index = $index) {
			<ngx-accordion-item [disabled]="item.isUpcoming">
				<ng-template #headerTmpl let-isOpen>
					<ng-container
						[ngTemplateOutlet]="timelineHeaderTmpl"
						[ngTemplateOutletContext]="{ item: item, index: index, isOpen: isOpen }"
					></ng-container>
				</ng-template>

				<ng-template #contentTmpl let-isOpen>
					<ng-container
						[ngTemplateOutlet]="timelineContentTmpl"
						[ngTemplateOutletContext]="{ item: item, index: index }"
					></ng-container>
				</ng-template>
			</ngx-accordion-item>
		}
	</ngx-accordion>
} @else {
	@for (item of timelineItems; track item; let index = $index) {
		<ng-container
			[ngTemplateOutlet]="timelineHeaderTmpl"
			[ngTemplateOutletContext]="{ item: item, index: index }"
		></ng-container>
		<ng-container
			[ngTemplateOutlet]="timelineContentTmpl"
			[ngTemplateOutletContext]="{ item: item, index: index }"
		></ng-container>
	}
}

<ng-template #timelineHeaderTmpl let-item="item" let-index="index" let-isOpen="isOpen">
	<vloket-timeline-item-header
		[index]="index"
		[title]="item.title"
		[date]="item.date"
		[descriptions]="item.descriptions"
		[links]="item.links"
		[step]="item.step"
		[isUpcoming]="item.isUpcoming"
		[isCurrent]="item.isCurrent"
		[isFirst]="item.isFirst"
		[isLast]="item.isLast"
		[isCondensed]="isCondensed"
		[isExpanded]="isOpen"
	/>
</ng-template>

<ng-template #timelineContentTmpl let-item="item" let-index="index">
	<vloket-timeline-item-body
		[index]="index"
		[title]="item.title"
		[date]="item.date"
		[descriptions]="item.descriptions"
		[links]="item.links"
		[step]="item.step"
		[isUpcoming]="item.isUpcoming"
		[isCurrent]="item.isCurrent"
		[isFirst]="item.isFirst"
		[isLast]="item.isLast"
		[isCondensed]="isCondensed"
	/>
</ng-template>
